import { render, staticRenderFns } from "./aside-messages-svg.vue?vue&type=template&id=3bcb06c7&scoped=true"
import script from "./aside-messages-svg.vue?vue&type=script&lang=js"
export * from "./aside-messages-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcb06c7",
  null
  
)

export default component.exports